import * as React from 'react';
import { Modal } from 'semantic-ui-react';

import { RenameList } from './RenameList';

interface AlphaRenameListProps {
  listId: string;
  dispatchRenameList: (id: string, name: string) => void;
  currentListName: string;
  openModal: boolean;
  handleCloseModal: () => void;
}

interface AlphaRenameListState {
  listName: string;
  showModal: boolean;
}

export class AlphaRenameList extends React.Component<AlphaRenameListProps, AlphaRenameListState> {
  constructor(props: AlphaRenameListProps) {
    super(props);
    this.state = {
      listName: this.props.currentListName,
      showModal: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps: AlphaRenameListProps) {
    if (this.props.currentListName !== nextProps.currentListName) {
      this.setState({ listName: nextProps.currentListName });
    }
  }

  handleChangeInput = (_: any, data: any) => {
    this.setState({ listName: data.value });
  };

  handleRenameList = () => {
    this.props.dispatchRenameList(this.props.listId, this.state.listName);
    this.props.handleCloseModal();
    this.setState({ listName: '', showModal: false });
  };

  render() {
    return (
      <Modal size="small" closeIcon={this.props.openModal} open={this.props.openModal} onClose={this.props.handleCloseModal}>
        <Modal.Content>
          <RenameList handleRenameList={this.handleRenameList} handleChangeInput={this.handleChangeInput} listName={this.state.listName} />
        </Modal.Content>
      </Modal>
    );
  }
}
